import { render } from "./LoginSuccess.vue?vue&type=template&id=2e43370a&scoped=true"
import script from "./LoginSuccess.vue?vue&type=script&lang=js"
export * from "./LoginSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e43370a"]])

export default __exports__